import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  inject
} from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Subject, takeUntil } from 'rxjs';
import { CalendarService } from 'src/app/_services/calendar.service';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-delete-event-modal',
  templateUrl: './delete-event-modal.component.html',
  styleUrls: ['./delete-event-modal.component.css']
})
export class DeleteEventModalComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Output() notifyPartent: EventEmitter<any> = new EventEmitter<any>();

  // dati che arrivano in input dalla modale
  readonly modalData: any = inject(NZ_MODAL_DATA);

  user: any;
  startDate: Date = new Date();
  endDate: Date = new Date();
  request: any;
  text: string;
  private readonly destroy$: Subject<void> = new Subject<void>();

  constructor(
    private readonly modalRef: NzModalRef,
    private readonly calendarService: CalendarService
  ) {
    super();
  }

  ngOnInit() {
    this.user = this.modalData.user;
    this.startDate = this.modalData.startDate;
    this.endDate = this.modalData.endDate;
    this.request = this.modalData.request;

    if (this.request.start_time && this.request.end_time) {
      const [startHours, startMinutes] = this.request.start_time
        .split(':')
        .map(Number);
      const [endHours, endMinutes] = this.request.end_time
        .split(':')
        .map(Number);
      this.startDate = new Date(this.request.start_date);
      this.startDate.setHours(startHours, startMinutes || 0, 0);
      this.endDate = new Date(this.request.end_date);
      this.endDate.setHours(endHours, endMinutes || 0, 0);
    }
    switch (this.request.type) {
      case 'Permesso':
        this.text = 'Richiesta di permesso';
        return this.text;
      case 'Ferie':
        this.text = 'Richiesta di ferie';
        return this.text;
      case 'Smart':
        this.text = 'Richiesta di Smart';
        return this.text;
      case 'Malattia':
        this.text = 'Richiesta di Malattia';
        return this.text;
      case 'Review':
        this.text = 'Review';
        return this.text;
      default:
        this.text = 'Richiesta di smart';
        return this.text;
    }
  }

  capitalizeFirst(text: string | null): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  closeModal() {
    this.modalRef.close();
  }

  confirmDelete() {
    this.calendarService
      .deleteEventRequest(this.request.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.responseToast('success', res.message);
          this.notifyPartent.emit('');
        },
        error: (err: any) => {
          this.responseToast('error', err.error.message);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
